var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAzreact = function SvgAzreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B9E4",
    d: "M24 9H0V3.533C0 3.267.15 3 .45 3h23.1c.3 0 .45.267.45.533z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F9C35",
    d: "M23.55 21H.45c-.3 0-.45-.267-.45-.533V15h24v5.467c0 .266-.15.533-.45.533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED2939",
    d: "M24 9H0v6h24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 15c.98 0 1.85-.47 2.398-1.196a2.5 2.5 0 1 1 0-3.607A3 3 0 1 0 12 15m3.652-3.77-.32-.897-.318.897-.86-.408.409.86-.897.318.897.319-.409.86.86-.409.319.897.319-.897.86.409-.41-.86L17 12l-.897-.319.408-.86z",
    clipRule: "evenodd"
  })));
};
export default SvgAzreact;